export const redirects = {
  bookshelf: "You will now be redirected to the bookshelf.",
  library: "You will now be redirected to the library.",
  landing_page: "You will now be redirected to the landing page.",
};
